import type { PartnerReturnsSettings, PartnerSearchReturnsSettingsV1Params } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const returnSettings = {
  search: {
    queryKey: 'partner-management-service/return-settings',
    fn: async (params: PartnerSearchReturnsSettingsV1Params = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerReturnsSettings[]>(
        '/partner-management-proxy/api/v1/partners/returnSettings',
        { params },
      );

      return data;
    },
  },
};
